<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <CardIeaApp colorCard="#A7BA38" title="Olvidé mi usuario">
          <v-form ref="form" v-model="valid" lazy-validation @submit="login()">
            <v-row align="center">
              <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[0]" />
              </v-col>
              <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[1]" />
              </v-col>
            </v-row>
          </v-form>
        </CardIeaApp>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <v-btn
          @click="recoverUser()"
          block
          x-large
          class="white--text rounded-lg font-weight-regular"
          depressed
          color="btnSuccess"
          :disabled="!valid"
          :loading="loader"
          >Recuperar usuario</v-btn
        >
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <v-btn
          @click="login()"
          block
          x-large
          class="grey--text text-decoration-underline font-weight-regular"
          depressed
          text
          color="#FFFFFF"
          :disabled="!valid"
          :loading="loader"
          >Ingresar</v-btn
        >
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <v-btn
          @click="olvidoPass()"
          block
          x-large
          class="grey--text text-decoration-underline font-weight-regular"
          depressed
          text
          color="#FFFFFF"
          :disabled="!valid"
          :loading="loader"
          >Olvíde mi contraseña</v-btn
        >
      </v-col>
      <br /><br /><br /><br /><br />
       <v-row v-if="username !== ''">
        <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
          <v-alert
            prominent
            type="info"
          >
           Tu usuario es: <strong>{{username}}</strong>
          </v-alert>
        </v-col>
      </v-row>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"></v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// @ is an alias to /src
import CardIeaApp from "../components/CardIeaApp";
import CardIeaAppMain from "../components/CardIeaAppMain";
import InputCustom from "../components/InputCustom";
import MessagesRules from "../config/MessagesRules";
export default {
  name: "RecoverUser",
  components: {
    CardIeaApp,
    InputCustom,
    CardIeaAppMain
  },
  computed: {
    loader() {
      return this.$store.getters.loader;
    }
  },
  data: () => ({
    valid: true,
    username:'',
    inputs: [
      {
        tag: "dni",
        text: "DNI",
        placeholder: "",
        icon: "mdi-account-box-outline",
        required: true,
        value: "",
        type: "DNI",
        rules: [v => !!v || "DNI" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "fechaNacimiento",
        text: "Fecha de nacimiento",
        placeholder: "dd/mm/YYYY",
        icon: "mdi-calendar",
        required: true,
        value: "",
        type: "date",
        rules: [v => !!v || "Fecha de nacimiento " + MessagesRules.required],
        counter: 0,
        config: {
          view: false
        }
      },
    ]
  }),
  methods: {
    async recoverUser() {
      this.username = '';
      let that = this;
      if (this.$refs.form.validate()) {
        await this.$API
          .post({
            url: "alumno/recoverUser",
            data: that.inputs,
            form: true
          }, false)
          .then(res => {
            this.username = res;
          });
      }
    },
    async login() {
      this.$router.replace({ name: "Login" });
    },
    async olvidoPass() {
      this.$router.replace({ name: "ResetPassword" });
    },
  }
};
</script>

<style scope>
  input[type="date"]::-webkit-inner-spin-button,
  input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
</style>
